import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { alpha, useTheme } from '@mui/material';
import { TileScope } from '@api/models/dashboard/TileScope';

interface Props {
  scope: TileScope;
}

export const ScopeBadge: FC<Props> = ({ scope }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (scope === 'personal') return null;

  const isCompany = scope === 'company';
  const bgColor = isCompany ? theme.palette.warning.main : theme.palette.info.main;
  const textColor = isCompany ? theme.palette.warning.dark : theme.palette.info.dark;
  const label = t(isCompany ? 'analytics.scope.company' : 'analytics.scope.global');

  return (
    <span
      style={{
        display: 'inline-block',
        borderRadius: '999px',
        padding: '0.15rem 0.55rem',
        backgroundColor: alpha(bgColor, 0.14),
        color: textColor,
        fontSize: '0.7rem',
        fontWeight: 600,
        letterSpacing: '0.02em',
        lineHeight: 1.5,
      }}
    >
      {label}
    </span>
  );
};
